import { render, staticRenderFns } from "./OtherProductOption.vue?vue&type=template&id=f936f4a4&"
import script from "./OtherProductOption.vue?vue&type=script&lang=ts&"
export * from "./OtherProductOption.vue?vue&type=script&lang=ts&"
import style0 from "./OtherProductOption.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports